export default "__VITE_ASSET__B4wqFKc6__"